import { isDateTimeControl, rankWith } from "@jsonforms/core";

export default rankWith(5, isDateTimeControl);
